import { baseApi } from "@/shared/api/baseApi";
import {
  parseResourceAvailability,
  type ResourceAvailability,
} from "@/features/chat/resourceAvailabilitySchemas";

export const resourceAvailabilityApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getResourceAvailability: builder.query<ResourceAvailability, string>({
      providesTags: (_result, _error, organizationId) => [
        { id: organizationId, type: "ResourceAvailability" },
      ],
      query: (organizationId) =>
        `/v1/organizations/${encodeURIComponent(organizationId)}/resource-availability`,
      transformResponse: parseResourceAvailability,
    }),
  }),
});

export const { useGetResourceAvailabilityQuery } = resourceAvailabilityApi;
